module.exports = __webpack_public_path__ + "img/img_banner_size02.3ff3bbd9.svg";